<template>
	<Transition
		enter-active-class="transition-opacity duration-300 ease-out"
		enter-from-class="opacity-0"
		enter-to-class="opacity-100"
		leave-active-class="transition-opacity duration-200 ease-in"
		leave-from-class="opacity-100"
		leave-to-class="opacity-0"
	>
		<section
			v-if="isVisible"
			class="fixed inset-0 z-3002 flex items-end justify-center sm:items-center"
		>
			<div
				class="absolute inset-0 bg-black/60 backdrop-blur-sm"
				@click="toggleInfoModal"
				@wheel.prevent
				@touchmove.prevent
				@scroll.prevent
			></div>

			<Transition
				enter-active-class="transition-all duration-400 ease-out"
				enter-from-class="opacity-0 translate-y-full sm:scale-95 sm:translate-y-8"
				enter-to-class="opacity-100 translate-y-0 sm:scale-100"
				leave-active-class="transition-all duration-250 ease-in"
				leave-from-class="opacity-100 translate-y-0 sm:scale-100"
				leave-to-class="opacity-0 translate-y-full sm:scale-95 sm:translate-y-4"
				appear
			>
				<div
					v-if="isVisible"
					class="relative w-full max-h-[85vh] bg-white shadow-2xl transform-gpu sm:w-11/12 sm:max-w-2xl sm:rounded-xl sm:max-h-[80vh] rounded-t-3xl overflow-hidden"
				>
					<!-- Header -->
					<Transition
						enter-active-class="transition-all duration-500 ease-out delay-100"
						enter-from-class="opacity-0 translate-y-[-10px]"
						enter-to-class="opacity-100 translate-y-0"
						appear
					>
						<header
							class="sticky top-0 z-10 bg-white border-b border-gray-100 px-4 py-4 sm:px-6"
						>
							<div class="flex items-center justify-between">
								<div class="flex items-center gap-3">
									<div class="p-2 bg-blue-50 rounded-xl">
										<img
											v-if="currentSector?.icon"
											:src="currentSector?.icon"
											alt="sector icon"
											class="w-6 h-6"
										/>
									</div>
									<div>
										<h1
											class="text-lg font-bold text-gray-900 leading-tight"
											v-html="currentSector?.title"
										></h1>
									</div>
								</div>

								<button
									@click="toggleInfoModal"
									class="p-2 hover:bg-gray-100 rounded-xl transition-colors duration-200 active:scale-95 transform cursor-pointer"
								>
									<svg
										xmlns="http://www.w3.org/2000/svg"
										width="20"
										height="20"
										viewBox="0 0 24 24"
										fill="none"
										stroke="currentColor"
										stroke-width="2"
										stroke-linecap="round"
										stroke-linejoin="round"
										class="text-gray-500"
									>
										<line x1="18" y1="6" x2="6" y2="18"></line>
										<line x1="6" y1="6" x2="18" y2="18"></line>
									</svg>
								</button>
							</div>
						</header>
					</Transition>

					<!-- Content -->
					<main
						class="overflow-y-auto max-h-[calc(85vh-120px)] sm:max-h-[calc(80vh-120px)]"
					>
						<Transition
							enter-active-class="transition-all duration-600 ease-out delay-200"
							enter-from-class="opacity-0 translate-y-4"
							enter-to-class="opacity-100 translate-y-0"
							appear
						>
							<div class="px-4 py-6 sm:px-6 pb-18">
								<div
									class="prose prose-gray max-w-none text-gray-700 leading-relaxed text-base [&>p]:mb-4 [&>p:last-child]:mb-0"
									v-html="currentSector?.description"
								></div>
							</div>
						</Transition>
					</main>
				</div>
			</Transition>
		</section>
	</Transition>
</template>

<script lang="js" src="./InfoModal.js"></script>

<style scoped>
.prose {
	line-height: 1.6;
}

main {
	-webkit-overflow-scrolling: touch;
	scroll-behavior: smooth;
}

h1 {
	word-break: break-word;
	hyphens: auto;
}

@supports (height: 100dvh) {
	.max-h-\[85vh\] {
		max-height: 85dvh;
	}
}
</style>
